import React from "react";
import { LoanContainer } from "../../../containers";

const Loans = (props) => {
  return <LoanContainer {...props} />;
};

export default Loans;
